function getCookieValue(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(";").shift()

  return null
}

function getStoreByKeyValue(key, valueKey) {
  key = `${pipelineConfig.pathPrefix}:${key}`
  const data = window.localStorage.getItem(key) ?? null
  let store = null

  if (data) {
    store = JSON.parse(data)
  }
  if (store && store.values && valueKey && store.values[valueKey]) {
    return store.values[valueKey]
  }
  return store ?? null
}

function getFromLocalStorage(key) {
  const LOCAL_STORAGE_KEY = "data"
  const val = getStoreByKeyValue(LOCAL_STORAGE_KEY, key)
  return typeof val === "string" ? val : null
}

export class TrackingServiceSegment {
  constructor(pipelineConfig) {
    this.defaultParameters = {
      pageCode: window.location.pathname.split(pipelineConfig.pathPrefix)[1].split("/")[0] || null,
      pipe: pipelineConfig.pathPrefix,
      claritySesssionID: decodeURIComponent(getCookieValue("_clsk")).split("|")[0] || null,
      pipe_id: pipelineConfig.pipelineId,
      language: pipelineConfig.language,
      geography: pipelineConfig.geography,
      brand_code: pipelineConfig.brandCode,
      pipe_series: pipelineConfig.series,
      eventSourceSystem: "cppv3",
      eventSourcePlatform: "web",
      klaviyoAccount: window.pipelineConfig.klaviyoPublicKey || null,
    }

    const initSegmentMiddleware = () => {
      if (window.analytics && window.analytics.addSourceMiddleware) {
        window.analytics.addSourceMiddleware(({ payload, next }) => {
          const defaultProperties = payload.obj.properties

          payload.obj.properties = Object.assign({}, defaultProperties, this.defaultParameters)
          const emailValue = getFromLocalStorage("email")
          if (emailValue) {
            payload.obj.properties.email = emailValue
          }

          next(payload)
        })
      } else {
        console.error(`[Segment] Analytics not available:`)
      }
    }

    initSegmentMiddleware()
  }

  mergeData(data) {
    return { ...this.defaultParameters, ...data }
  }

  internalIsUserIdentified() {
    const store = window.Alpine.store("data")
    const storeData = (store && store.values) || {}
    const data = { segmentUserId: storeData.segmentUserId || "" }

    if (!storeData.segmentUserId || !storeData.email) return

    this.isUserIdentified(data).then((isIdentified) => {
      if (!isIdentified) {
        data.email = storeData.email
        this.trackIdentify(data)
      }
    })
  }

  trackClick(customData) {
    this.internalIsUserIdentified()
    const data = this.mergeData(customData)

    window.analytics.track("click", data)
  }

  trackPageView() {
    this.internalIsUserIdentified()
    window.analytics.page(this.defaultParameters.pageCode)
  }

  trackIdentify(customData) {
    const data = this.mergeData(customData)

    window.localStorage.setItem("ajs_user_id", data.segmentUserId)
    window.analytics.identify(data.segmentUserId, { email: data.email })
  }

  trackSystemEvent(customData) {
    this.internalIsUserIdentified()
    const data = this.mergeData(customData)

    window.analytics.track("system event", data)
  }

  resetUserData() {
    window.analytics.reset()
    window.analytics.setAnonymousId()
  }

  setEventToSessionStorage(customData) {
    // Do nothing, cause segment covers this edge-cases
  }

  trackSessionStorageClickEvent(payload) {
    // Do nothing, cause segment covers this edge-cases
  }

  async isUserIdentified(customData) {
    if (!customData.segmentUserId) {
      return false
    }

    // Sanitize because of different browsers
    let rawValue = localStorage.getItem("ajs_user_id")
    let segmentUserId
    try {
      segmentUserId = JSON.parse(rawValue)
    } catch {
      segmentUserId = rawValue
    }

    if (segmentUserId !== customData.segmentUserId) {
      return false
    }

    return true
  }
}
